module.exports = "/_next/static/images/2390d7f26f77f3711c59e734945521e0-blog-1x.jpg";